import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { AuthService } from '@abp/ng.core';
import { Observable } from 'rxjs';
import { AppState } from '../../../app.state';
import { VendorDto } from '../../../proxy/vendors/models';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { AttachmentService } from '../../../proxy/common/attachment.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { VendorService } from '../../../proxy/vendors/vendor.service';
import { environment } from 'src/environments/environment';
import { ManageProfileVendorComponent } from 'src/app/account/manage-profile-vendor/manage-profile-vendor.component';
import { UserProfileDto } from 'src/app/proxy/users/models';
import { AppImages } from 'src/resources/app_images';
import { UserProfileService } from 'source/app/proxy/users';
import { GetUserProfile, GetVendor } from 'source/app/app.actions';

@Component({
    selector: 'app-vendor-layout',
    templateUrl: './vendor-layout.component.html',
    styleUrls: ['./vendor-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VendorLayoutComponent implements OnInit {

  readonly logoUrl = AppImages.focaliLogo192Path;

  loading = true;

  @Select(AppState.getVendor)
  vendor$: Observable<VendorDto[]>;
  vendor: VendorDto;

  id: string;

  entityName = 'vendor';
  previewUrl: string;

  supportMail: string;

  currentApplicationVersion = `v${environment.appVersion}`;

  userProfile: UserProfileDto;

  constructor(
    private authService: AuthService,
    private nzDrawerService: NzDrawerService,
    private attachmentService: AttachmentService,
    private oAuthService: OAuthService,
    private vendorService: VendorService,
    private store: Store,
    private userProfileService: UserProfileService,
  ) {}

  isLoggedIn() {
    return this.oAuthService.hasValidAccessToken();
  }

  ngOnInit(): void {
  if (!this.isLoggedIn()) {
    this.authService.navigateToLogin();
    return;
  }

  this.userProfileService.getCurrentUser().subscribe(profile => {
    this.userProfile = profile;
  });

  this.store.dispatch(new GetUserProfile()).subscribe({
    next: () => {
      this.store.dispatch(new GetVendor()).subscribe({
        next: () => {
          this.vendor$.subscribe(u => {
            if (u && u.length > 0) {
              this.vendor = u[0];
              this.id = this.vendor.id;
              this.getPicture();
              this.getSupportMail();
            }
          });
        },
        error: err => console.error('GetVendor failed:', err)
      });
    },
    error: err => console.error('GetUserProfile failed:', err)
  });
}

  getPicture() {
    this.attachmentService
      .download(this.vendor.id, `${this.entityName}/picture/${this.vendor.id}`)
      .subscribe({
        next: s => {
          if (s && s.content) {
            this.previewUrl = `data:${s.type};base64,${s.content}`;
          }
        },
        error: err => console.warn('Vendor picture could not be loaded:', err),
      });
  }

  getSupportMail() {
    const countryCode = this.vendor?.country?.code;

    if (!countryCode) {
      this.supportMail = '';
      return;
    }

    this.vendorService.getSupportMailByCountryCode(countryCode).subscribe({
      next: s => {
        this.supportMail = s || '';
      },
      error: err => {
        this.supportMail = '';
        console.warn('Vendor support mail could not be loaded:', err);
      },
    });
  }

  profileClick() {
    this.nzDrawerService.create<ManageProfileVendorComponent, any>({
      nzContent: ManageProfileVendorComponent,
      nzBodyStyle: {
        backgroundColor: '#f2f2f3',
      },
      nzWidth: '40%',
      nzContentParams: {},
      nzCloseOnNavigation: false,
    });
  }
}
